import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { installOnvifDiscoveryFetch } from './services/installOnvifDiscoveryFetch';

Amplify.configure(awsExports);
installOnvifDiscoveryFetch();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
